import script from "./popper.vue?vue&type=script&lang=js"
export * from "./popper.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__